import(/* webpackMode: "eager", webpackExports: ["TermConditionPage"] */ "/www/wwwroot/gass/fe-new/components/legal/term-condition-page.tsx");
